import {
  Image as MantineImage,
  BackgroundImage as MantineBackgroundImage,
} from "@mantine/core";
import { getOptimizedImageUrl } from "@/lib/optimized-image-url";

// CMS-supplied image URLs are served unoptimized and can be several MB;
// route src through our own image proxy (pages/api/image-proxy.ts) instead
// of rendering it raw. Unlike Next's /_next/image, the proxy isn't limited
// to a fixed deviceSizes/imageSizes allowlist, so forward the component's
// own width/height as the requested size instead of always maxing out.
export function OptimizedImage({ src, width = undefined, height = undefined, ...rest }) {
  const resolvedWidth = Number(width) || Number(height) || undefined;
  return (
    <MantineImage
      src={getOptimizedImageUrl(src, resolvedWidth)}
      width={width}
      height={height}
      {...rest}
    />
  );
}

export function OptimizedBackgroundImage({ src, width = undefined, height = undefined, ...rest }) {
  const resolvedWidth = Number(width) || Number(height) || undefined;
  return (
    <MantineBackgroundImage
      src={getOptimizedImageUrl(src, resolvedWidth)}
      width={width}
      height={height}
      {...rest}
    />
  );
}
